import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SFOnDutyApi } from '../../shared/sdk/index';
import { Observable } from 'rxjs/Observable';

/*
  Generated class for the OnDutyDestinationsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class OnDutyDestinationsProvider {

  constructor(
    public http: HttpClient,
    public SFOnDutyApi:SFOnDutyApi
  ) {
    console.log('Hello OnDutyDestinationsProvider Provider');
  }

  get():Observable<any> {
    return new Observable((observer)=>{
      this.SFOnDutyApi.getOnDutyDestinations().subscribe(
        result=>{
          observer.next(result);
          observer.complete();
        },
        error=>{
          console.log("ERROR",error);
          observer.error(error);
        }
      )
    })
    
  }

}



// WEBPACK FOOTER //
// ./src/providers/on-duty-destinations/on-duty-destinations.ts